import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Link } from '@design-system/link';
export const OptionalLink = (_a) => {
    var { ariaLabel, children, styledOnlyOnHover, to } = _a, rest = __rest(_a, ["ariaLabel", "children", "styledOnlyOnHover", "to"]);
    if (!to) {
        return _jsx(Box, Object.assign({}, rest, { children: children }));
    }
    return (_jsx(Link, Object.assign({ "aria-label": ariaLabel, styledOnlyOnHover: styledOnlyOnHover, to: to }, rest, { children: children })));
};
//# sourceMappingURL=OptionalLink.js.map